export default "__VITE_ASSET__db84d2fe__"